<template>
  <div class="technical-details-table-fi">
    <table-fi
      v-if="attributes || item.catalogProductData.Attributes"
      class="technical-details-table-fi__table"
    >
      <template #default>
        <tbody>
          <tr
            v-for="(attribute, attributeIndex) in attributes || item.catalogProductData.Attributes"
            :key="attributeIndex"
            class="technical-details-table-fi__table-row"
          >
            <td class="technical-details-table-fi__table-column--left">
              <template v-if="attribute.AttributeName">
                <span class="technical-details-table-fi__attribute-name">
                  {{ attribute.AttributeName }}
                  <icon-fi
                    v-if="isSpecialAttributeName(attribute)"
                    class="technical-details-table-fi__attribute-icon"
                    icon="screw"
                  />
                  <!-- eslint-disable vue/no-v-html -->
                  <span
                    v-else-if="!technicalNamesDisabled && attribute.TechnicalName"
                    class="technical-details-table-fi__technical-name"
                    v-html="`(${attribute.TechnicalName})`"
                  />
                  <!-- eslint-disable vue/no-v-html -->
                </span>
              </template>
            </td>

            <td class="technical-details-table-fi__table-column--right">
              <span
                v-if="!attribute.Value"
                class="technical-details-table-fi__attribute-value--dash"
              >
                &#8212;
              </span>
              <span
                v-else-if="attribute.Value === 'relevant'"
                class="technical-details-table-fi__attribute-value--check"
              >
                <icon-fi
                  class="technical-details-table-fi__attribute-value-icon"
                  icon="check"
                />
              </span>
              <!-- eslint-disable vue/no-v-html -->
              <span
                v-else
                class="technical-details-table-fi__attribute-value"
                v-html="attribute.Value"
              />
              <span
                v-if="attribute.Unit"
                v-html="` ${getBlankUnit(attribute.Unit)}`"
              />
              <!-- eslint-enable vue/no-v-html -->
            </td>
          </tr>
          <tr v-if="slugLink && showDataInfo">
            <td
              colspan="2"
              class="technical-details-table-fi__table-column--right"
            >
              <div class="technical-details-table-fi__link">
                <link-fi
                  :href="slugLink"
                  secondary
                  :size="18"
                >
                  {{ $dict.get('product-List.Table.Data-Info') }}
                </link-fi>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </table-fi>
  </div>
</template>

<script>
import { IconFi, LinkFi, TableFi } from 'atoms';
import slugLinkMixin from 'mixins/slugLinkMixin';

export default {
  name: 'TechnicalDetailsTableFi',
  components: {
    IconFi,
    LinkFi,
    TableFi,
  },
  mixins: [slugLinkMixin],
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    attributes: {
      type: Array,
      default: null,
    },
    technicalNamesDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDataInfo: false, // default: true XXX
    };
  },
  computed: {
    slugLink() {
      return this.getSlugLink(this.item.catalogProductData);
    },
  },
  methods: {
    isSpecialAttributeName(attribute) {
      return attribute?.TechnicalName && attribute.AttributeKey === 'SCHL_WEITE';
    },
    getBlankUnit(unit) {
      return unit.toString().replace(/[[\]]/g, '');
    },
  },
};
</script>

<style lang="scss">
@import './technical-details-table-fi-unscoped.scss';
</style>

<style lang="scss" scoped>
@import './technical-details-table-fi.scss';
</style>
